<template>
  <div class="ManageSystem" id="ManageSystem">
    <el-tabs type="border-card" @tab-click="handleClick" v-model="activeName">
      <el-tab-pane v-for="(item,index) in statemList" :key="index" :label="item.name" :name="item.name">
        <span slot="label">{{item.system_name}}</span>
      </el-tab-pane>
    </el-tabs>
    <component :is="url" :url="clickUrl" class="contentView"></component>

  </div>
</template>

<script>
import { Role_Rampow, Role_iVANKY, Role_DB, Role_WMS, ManageRole, Role_Bonoch, systemTab } from './components'
import { hasPermission } from '@/utils/index.js'
import {system} from '@/api/role'
export default {
  data(){
    return{
      statemList:[
      ],
      searchForm:{
        name:{value:""}
      },
      tableList:[],
      pidList:[],
      url:"",
      clickUrl:"",
      activeName:""
    }
  },
  created(){
    this.getSystem()
  },
  components:{
    ManageRole,
    systemTab
  },

  methods:{
    handleClick(tab){
      let label = tab.label
      let curTarget = this.statemList[tab.index]
      if(label === 'IVANKY'){
        this.url = Role_iVANKY
        this.clickUrl = ''
      }else if(label === 'PUBLIC'){
        this.url = ManageRole
        this.clickUrl =""
      }else if(label === 'RAMPOW'){
        this.url = Role_Rampow
        this.clickUrl =""
      }else if(label === 'WMS') {
        this.url = Role_WMS
        this.clickUrl =""
      }else if(label === 'BONOCH') { 
        this.url = Role_Bonoch
        this.clickUrl =""
      }else{
        this.url = systemTab
        this.clickUrl = './system.html?url='+curTarget.system_url_role
      } 
    },
    getSystem(){
      let params = {
        // role: 1
      }
      system(params).then(res=>{
        if(res.PUBLIC){
          let list = [] 
          for(let i in res){
            res[i].weight = this.setSystemWeight(i)
            res[i].name = i
            let isPublick = i == 'PUBLIC' &&  hasPermission('/role')
            let isRAMPOW = i == 'RAMPOW' &&  hasPermission('/rampow_role')
            let isDB = i == 'DB' &&  hasPermission('/db_role')
            let isIVANKY = i == 'IVANKY' &&  hasPermission('/ivanky_role')
            let isWMS = i == 'WMS' &&  hasPermission('/wms_role')
            let isBonoch = i == 'BONOCH' &&  hasPermission('/bonoch_role')
            
            if (i != 'PUBLIC' && i != 'RAMPOW'  && i != 'DB' &&  i!= 'IVANKY'  && i != 'WMS' && i!= 'BONOCH'){
              list.push(res[i])
            } else if(isPublick){
              list.push(res[i])
            } else if(isRAMPOW){
              list.push(res[i])
            } else if (isDB) {
              list.push(res[i])
            }else if (isIVANKY) {
              list.push(res[i])
            }else if (isWMS) {
              list.push(res[i])
            }else if (isBonoch) {
              list.push(res[i])
            }
          }
          list.sort(function(a,b){
            return (a.weight - b.weight)
          })
         
          this.statemList= list
        
          if(list.length > 0){
            let key = list[0].name
            this.activeName = list[0].name
            if(key === 'IVANKY'){
              this.url = Role_iVANKY
              this.clickUrl = ''
            }else if(key === 'PUBLIC'){
              this.url = ManageRole
              this.clickUrl =""
            }else if(key === 'RAMPOW'){
              this.url = RampowRole
              this.clickUrl =""
            } else if(key === 'DB') {
              this.url = Role_DB
              this.clickUrl =""
            } else if(key === 'WMS') { //
              this.url = Role_WMS
              this.clickUrl =""
            } else if(key === 'BONOCH') { //
              this.url = Role_Bonoch
              this.clickUrl =""
            }else {
              this.url = systemTab
              this.clickUrl = './system.html?url='+res[key].system_url_role
            }
          }

        }
       
      })
    },
    setSystemWeight(i){
      let weight = 0
      switch (i){
        case 'ERP':
          weight = 1;
          break;
        case 'EHR':
          weight = 2;
          break;
        case 'ECP':
          weight = 3;
          break;
        case 'FAS':
          weight = 4;
          break;
        case 'WMS':
          weight = 5;
          break;
        case 'RAMPOW':
          weight = 6;
          break;
        case 'IVANKY':
          weight = 7;
          break;
        case 'BONOCH':
          weight = 8;
          break;
        case 'DB':
          weight = 9;
          break;
        case 'PUBLIC':
          weight = 10;
          break;
        
      }
      return weight
    }
  }

}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
#ManageSystem{
  padding: 32px 40px;
  background-color: #ffffff;
  .searchFrom{margin-left: 0;}
  .tableContainer{padding: 0;}
  .btnContainer>.btn:nth-of-type(1){margin-left: 0;}
  .formBtnContainer>.btn:nth-of-type(n){margin-right: 0;}
  .searchFormBtn{padding: 0;position: relative;left: -3px;}
}
.ManageSystem{
  width: 100%;
  height: 100%;
  box-shadow: none;
  border: none;
}
iframe,.contentView{
  width: 100%;
  height: 95%;
  box-shadow: none;
  border: none;
}
.el-tabs{
  box-shadow: none;
  border: none;
}

.el-tabs--border-card
{
  >.el-tabs__content{
    width: 100%;
    height:95%;
    position: inherit;
    padding: 0;
    background-color: #ffffff;
    >div{
      width: 100%;
      height: 100%;
    }
  }
  >.el-tabs__header{
    background-color: #ffffff;
    .el-tabs__item.is-active{
      border: 1px solid #cccccc;
      border-bottom: none;
    }
    .el-tabs__item{
      color: #030303; 
      text-align: center;
    }
    .el-tabs__item:first-of-type{
      left: 1px;
      border-top-left-radius: 4px;
      border-left: 1px solid #cccccc;
    }
    .el-tabs__item:nth-of-type(n){
      border-right: 1px solid #cccccc;
      border-top: 1px solid #CCC;
    }
    .el-tabs__item:last-of-type{
      border-top-right-radius: 4px;
    }
  }
  .el-tabs__nav{
    border-top: 1px solid #cccccc;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
} 


</style>